/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Spin,
  Modal,
  Row,
  Menu,
  Form,
} from 'antd';
import { getPuestos } from 'api/catalogos/puestos';
import { getAreas } from 'api/catalogos';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { deleteDescuento, getDescuentos, getDescuentosPlantillaExcel } from 'api/nominas/descuentos/descuentos';
import Table from 'components/Table';
import { formatReceivedValues } from 'utils/formatValues';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { onAlert, onError, onSuccess } from 'utils/handlers';
import API from 'utils/api';
// Componentes
import FormSubmitControls from 'components/FormSubmitControls';
import { DownloadOutlined, FileExcelOutlined } from '@ant-design/icons';
import Dragger from 'components/Dragger';
import ModalDelete from 'components/ModalDelete';
import DescuentosEmpleadosPercepciones from './DescuentosEmpleadosPercepciones';
import DescuentosEmpleadosDeducciones from './DescuentosEmpleadosDeducciones';
import DescuentosEmpleadosDescuentos from './DescuentosEmpleadosDescuentos';

const EmpleadosDescuentosMasivos = ({
  descuentoAsignacionMasiva,
  empleados = [],
  descuentoEmpleadoMasivoAutorizado,
  descuentoEmpleadoMasivoInactivo,
  tipoDescuento,
  permission,
  isBlocked,
  estatus,
}) => {
  const [loading, setLoading] = useState(false);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [administracionDePlazas, setAdministracionDePlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [data, setData] = useState([]);
  const [open, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [visibleModal, setVisibleModal] = useState(false);
  const [form] = Form.useForm();
  const [formExtra] = Form.useForm();
  const [formCarga] = Form.useForm();
  const [visibleAlert, setVisibleAlert] = useState(false);

  const baseURI = 'nominas/descuentos-empleados';
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const response = await API.get(baseURI, { params: { page, ...q, descuento_asignacion_masiva: descuentoAsignacionMasiva } });
      const { results } = response.data;
      setSelectedRowKeys([]);
      setPageActual(page);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page, ...q, descuento_asignacion_masiva: descuentoAsignacionMasiva } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        empleado_puesto: e?.empleado,
        empleado_area: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const normalizeData = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const unidad_responsable = normalizeData(clone.unidad_responsable);
        const centro_de_costo = normalizeData(clone.centro_de_costo);
        if (!unidad_responsable.length && !centro_de_costo.length) {
          delete clone.unidad_responsable;
          delete clone.centro_de_costo;
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            tableTitle: clone.descripcion,
            clave: clone.clave,
          });
        }
        if (unidad_responsable) {
          return ({
            id: clone.id,
            title: `${clone.clave} - ${clone.descripcion}`,
            value: `${clone.clave}/${clone.nivel}`,
            children: unidad_responsable,
            tableTitle: clone.descripcion,
            clave: clone.clave,
          });
        }
        return ({
          id: clone.id,
          title: `${clone.clave} - ${clone.descripcion}`,
          value: `${clone.clave}/${clone.nivel}`,
          children: centro_de_costo,
          tableTitle: clone.descripcion,
          clave: clone.clave,
        });
      });
      return output;
    }
    return false;
  };

  const areaBuscar = (value) => {
    const stack = [...areas];
    while (stack.length > 0) {
      const areaNueva = stack.pop();
      if (areaNueva.clave === value?.toString() || areaNueva.value === value?.toString()) {
        return areaNueva;
      }
      if (areaNueva.children) {
        stack.push(...areaNueva.children);
      }
    }
    return null;
  };

  useEffect(() => {
    // 1. Declaramos la variable 'mounted'
    let mounted = true;

    const fetchAll = async () => {
      setLoading(true);
      try {
        const [
          _puestos,
          _areas,
          _adminPlazas,
          _plazas,
          _data,
        ] = await Promise.all([
          getPuestos(),
          getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
          getAdministracionDePlazasvistaOptimized(),
          getPlazasvistaOptimized(),
          getDescuentos({ descuento_asignacion_masiva: descuentoAsignacionMasiva }),
        ]);

        const formattedURS = normalizeData(_areas);
        const results = formatReceivedClone(_data.results);

        // 2. Verificamos 'mounted' antes de usar setStates
        if (mounted) {
          setPuestos(_puestos);
          setAreas(formattedURS);
          setAdministracionDePlazas(_adminPlazas);
          setPlazas(_plazas);

          setData({ ..._data, results });

          setLoading(false);
        }
      } catch (error) {
        if (mounted) {
          setData([]);
          setLoading(false);
        }
      }
    };

    // 3. Estructura condicional sin 'return' temprano para satisfacer al linter
    if (!descuentoAsignacionMasiva) {
      if (mounted) {
        setData([]);
        setLoading(false);
      }
    } else {
      fetchAll();
    }

    // 4. Retorno consistente de la función de limpieza
    return () => { mounted = false; };
  }, [descuentoAsignacionMasiva]);

  const onCancel = () => {
    setVisible(false);
    setSelectedRowKeys([]);
  };

  const onClickEdit = () => {
    setVisible(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado_numero',
      key: 'empleado_numero',
      width: 160,
    },
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'empleado_numero_y_nombre_completo',
      key: 'empleado_numero_y_nombre_completo',
      width: 300,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 300,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 300,
    },
  ];

  const getSelectedRecordName = () => {
    if (!selectedRowKeys.length || !data?.results) return '';
    const record = data.results.find((item) => item.id === selectedRowKeys[0]);
    return record ? record.empleado_numero_y_nombre_completo : '';
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDescuento(key);
        if (deleted) {
          onSuccess('Registro eliminado correctamente');
          setVisibleAlert(false);
          setSelectedRowKeys([]); // Limpiar selección
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
      setLoading(false);
    }
  };

  // MODIFICA ESTA FUNCIÓN
  const onClickDelete = () => {
    if (estatus !== 1) {
      onAlert('El estatus actual no permite eliminar registros.');
      return;
    }
    if (selectedRowKeys.length === 0) {
      onAlert('Por favor seleccione un registro para eliminar.');
      return;
    }
    setVisibleAlert(true);
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const excel = await getDescuentosPlantillaExcel();
      if (excel) {
        const blob = new Blob([excel], {
          type: 'application/ms-excel',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Descuentos_Plantilla.xlsx';
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();

      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = `nominas/descuentos-asignaciones-masivas/${descuentoAsignacionMasiva}/cargar-plantilla/`;

        const response = await API.post(uri, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },

        });

        // CAMBIO EN MANEJO DE RESPUESTA:
        if (response?.status === 200) {
          // Mostrar mensaje del backend
          const msg = response.data.message || 'Carga realizada correctamente';

          if (response.data.errores && response.data.errores.length > 0) { /* ignore */ }
          onSuccess(response, msg, 5);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
      setVisibleModal(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={data?.results || []}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          currentPage={pageActual}
          cols={columns}
          allowExportParam={false}
          allowEdit={estatus === 1}
          allowSearch
          controls={{
            onClickEdit,
            onClickDelete,
          }}
          disableEdit={estatus !== 1}
          allowDoubleClick={estatus === 1}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          loading={loading}
          allowCustomImport
          customImportMenu={menuImport}
          customImportText="Importar Descuentos"
          allowImport
          baseURI={baseURI}
          permission={permission}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width="65%"
          title={(
            <FormSubmitControls
              label="Editar Descuento de Empleado"
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          {tipoDescuento?.requiere_identificar_percepciones
            ? (
              <Row>
                <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Percepciones</p>
                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                  <DescuentosEmpleadosPercepciones
                    descuentoEmpleado={selectedRowKeys[0]}
                    descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoMasivoAutorizado
                      || descuentoEmpleadoMasivoInactivo}
                    isBlocked={isBlocked}
                  />
                </div>
              </Row>
            ) : null}
          {tipoDescuento?.requiere_identificar_deducciones
            ? (
              <Row>
                <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Deducciones</p>
                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                  <DescuentosEmpleadosDeducciones
                    descuentoEmpleado={selectedRowKeys[0]}
                    descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoMasivoAutorizado
                      || descuentoEmpleadoMasivoInactivo}
                    isBlocked={isBlocked}
                  />
                </div>
              </Row>
            ) : null}
          {tipoDescuento?.requiere_identificar_descuentos
            ? (
              <Row>
                <p style={{ color: '#D88F4F', fontWeight: 600, marginBottom: 0 }}>Descuentos</p>
                <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                  <DescuentosEmpleadosDescuentos
                    descuentoEmpleado={selectedRowKeys[0]}
                    descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoMasivoAutorizado
                      || descuentoEmpleadoMasivoInactivo}
                    isBlocked={isBlocked}
                  />
                </div>
              </Row>
            ) : null}
        </Modal>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`el descuento de: ${getSelectedRecordName()}?`}
          loading={loading}
        />

        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
                  )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                // rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
      </Spin>
    </Row>
  );
};

export default EmpleadosDescuentosMasivos;
